import { Link } from "react-router-dom";

const CardWithImg = ({header, para, img, to}) => {

    return (
        <>
        <div class="card-with-image">
            <div class="card-image">
                <img src={img} alt="Tote bag" />
            </div>
            <div class="card-content">
                <h3>{header}</h3>
                <p>{para}</p>
                <Link to={to}>
                <a href="#">Shop now →</a>
                </Link>
            </div>
      </div>
        </>
    );
}

export default CardWithImg;